export default "__VITE_ASSET__eRYi8veZ__"